import React from "react";
import PropTypes from "prop-types";
import I18n from "lib/i18n";
import { track } from "lib/analytics";

const GOOGLE_ANALYTICS_CATEGORY = "Admin Topbar Menu";
const GOOGLE_ANALYTICS_ACTION = "Click";

const AdminMenuEntries = ({ adminActions }) => {
  if (!adminActions.length) {
    return null;
  }

  const actions = adminActions.map(({ path, label, icon, trackAction }) => {
    const iconElement = icon ? <i className={`icon-${icon}`} /> : null;
    const onClick = () => track(GOOGLE_ANALYTICS_CATEGORY, GOOGLE_ANALYTICS_ACTION, trackAction);

    return (
      <li key={path}>
        <a href={path} onClick={onClick}>{iconElement}{label}</a>
      </li>
    );
  });

  return (
    <React.Fragment>
      <li>
        <hr />
        <h4>{I18n.t("top_bar.label.admin")}</h4>
      </li>
      {actions}
    </React.Fragment>
  );
};

AdminMenuEntries.propTypes = {
  adminActions: PropTypes.arrayOf(PropTypes.shape({
    path: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
    trackAction: PropTypes.string.isRequired,
  })).isRequired,
};

export default AdminMenuEntries;
